@if (!state) {
    <div class="code-access-input">
        <form accept-charset="UTF-8" id="bookAccessCodeBoxForm" name="bookAccessCodeForm">
            <div class="code-access-header">
                <div class="header-logo">
                    <img [src]="'stickercode_check.png' | asset">
                </div>
                <div class="header-text">
                    <span>Gratis Digi.Buch</span><br>
                    Online-Angebot aktivieren!
                </div>
            </div>
            <div class="code-access-body">
                <div class="code-access-input-field">
                    <label class="code-access-code" for="bookAccessCodeInput">
                        CODE
                    </label>
                    <input [(ngModel)]="bookAccessCode.code" autocomplete="off" class="code-access-code"
                           id="bookAccessCodeInput" maxlength="14" name="book_link" required
                           type="text">
                </div>
                <div class="code-access-input-field" [style.visibility]="showPinInputField() ? 'visible' : 'hidden'"
                     [style.pointer-events]="showPinInputField() ? 'auto' : 'none'">
                    <label class="code-access-pin" for="bookAccessPinInput">PIN</label>
                    <input [(ngModel)]="bookAccessCode.pin" autocomplete="off" class="code-access-pin" id="bookAccessPinInput"
                           maxlength="4" name="book_pin" [required]="showPinInputField()">
                </div>
            </div>
            <div class="code-access-footer">
                <button (click)="onInfoClicked()" class="tw-btn tw-btn-dark tw-btn-small tw-p-1 tw-rounded tw-mr-1"
                        type="button">
                    <svg class="tw-w-4 tw-h-4 tw-fill-current" viewBox="0 0 192 512" xmlns="http://www.w3.org/2000/svg">
                        <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                        <path
                                d="M144 80c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM0 224c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V448h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64V256H32c-17.7 0-32-14.3-32-32z"/>
                    </svg>
                </button>
                <button (click)="sendBookAccessCode()" class="btn btn-sm code-access-submit" type="submit">Buch
                    aktivieren
                </button>
            </div>
        </form>
    </div>
}

@if (state === 'user_merge') {
    <div class="state">
        <a [attr.href]="'showMergeAccounts' | route" class="btn btn-sm code-access-submit ws-normal">
            <i aria-hidden="true" class="fa fa-user-circle fa-fw"></i> Nutzer zusammenführen
        </a>
    </div>
}


@if (state === 'd4s_code') {
    <div class="state">
        <div>
            <input [(ngModel)]="bookAccessCode.d4sCode" autocomplete="off" class="code-access-pin"
                   id="bookAccessD4sCodeInput"
                   name="book_d4sCode"
                   placeholder="Digi4School Code eingeben" required>
            <div class="code-access-footer">
                <button (click)="sendBookAccessCode()" class="btn btn-sm code-access-submit" type="submit">Buch
                    aktivieren
                </button>
            </div>
        </div>
    </div>
}

@if (['user_login', 'digi_user_conflict'].includes(state)) {
    <div class="state">
        <div>
            <a [attr.href]="'logoutUser' | route: { redirect: 'login' }" class="btn btn-sm code-access-submit">Mit anderem Benutzer anmelden</a>
        </div>
    </div>
}

@if (['d4s_code_not_activated', 'd4s_code_expired', 'digi_user_conflict', 'd4s_code_first', 'd4s_digi_user_conflict'].includes(state)) {
    <div class="state">
        <div>
            <a class="btn btn-sm code-access-submit" href="https://digi4school.at/anonym" rel="noopener noreferrer"
               target="_blank">Zum Login auf digi4school.at</a>
        </div>
    </div>
}

@if (state === 'd4s_code_first') {
    <div class="state">
        <div>
            <a class="btn btn-sm code-access-submit" (click)="activateNoD4SCode()">Mit Printcode aktivieren</a>
        </div>
    </div>
}

@if (state === 'd4s_d4s_user_conflict') {
    <div class="state">
        <div>
            <a class="btn btn-sm code-access-submit" href="/kontakt">Zum Kontaktformular</a>
        </div>
    </div>
}

@if (errMsg && isPremiumPlusError) {
    <div class="alert text-danger bg-white text-start" role="alert"><i aria-hidden="true" class="fa fa-info-circle"></i>&nbsp;<span
            [innerHTML]="errMsg"></span></div>
}
@if (errMsg && !isPremiumPlusError && errActMsg) {
    <div class="alert alert-warning" role="alert"><i aria-hidden="true" class="fa fa-info-circle"></i>&nbsp;<span
            [innerHTML]="errMsg + ' ' + errActMsg"></span></div>
}

@if (errMsg && !isPremiumPlusError && !errActMsg) {
    <div class="alert alert-warning" role="alert"><i aria-hidden="true" class="fa fa-info-circle"></i>&nbsp;<span
            [innerHTML]="errMsg"></span></div>
}
@if (errMsg && ['user_merge', 'd4s_code', 'user_login'].includes(state)) {
    <div class="alert-tip">
        Ist dein Freischaltcode im falschen Account eingelöst worden?<br>
        <div class="alert-tip-link"><strong><a [href]="bookAccessCodeResetURL">Stickercode zurücksetzen</a></strong>
        </div>
    </div>
}

